import config from "../config";
import { Company } from "../types";

export function findBackgroundColor(company: Company) {
    return config.goods.find(good => good.name === company.product_service)?.color || '#C0C0C0'
}